import { gql } from '@apollo/client';

export const GET_SEARCH_TV_COLLECTION = gql`
  query GetSearchTvCollection(
    $query: NonEmptyTrimmedString!
    $context: TvSearchContextType!
  ) {
    searchTvCollections(query: $query, context: $context) {
      id
      title
      season
      type
      boneUUID
    }
  }
`;
